import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { WEB_CONTENT_WIDTH } from '../../../../styles/constants';

/** Mirrors `UserBigItem.styles.ts`: one row — text block (flex) + action buttons. */
export const useStyles = makeStyles<Theme>()((theme) => ({
  communityWrapper: {
    ...theme.mixins.appClickableContainer,
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    display: 'flex',
    maxWidth: `calc(${WEB_CONTENT_WIDTH} - ${theme.spacing(2)})`,
    [theme.breakpoints.down('md')]: {
      maxWidth: `calc(100vw - ${theme.spacing(2)})`,
    },
  },

  avatarWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  communityDetails: {
    flex: '1',
    display: 'flex',
    alignItems: 'center',
    maxWidth: 'calc(100% - 64px)',
    minWidth: 0,
    height: '100%',
  },

  infoWrapper: {
    flex: '1',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(0.25),
    paddingRight: theme.spacing(1),
    height: '100%',
  },

  infoName: {
    ...theme.mixins.appEllipsis,
    maxWidth: '100%',
  },

  infoDescription: {
    ...theme.mixins.appEllipsis,
    maxWidth: '100%',
  },

  controlWrapper: {
    display: 'flex',
    flexShrink: 0,
    gap: '8px',
    alignItems: 'flex-start',
    padding: `${theme.spacing(1)} 0`,
  },
}));
